import React from 'react';
import styled from 'styled-components';
import { typography, color } from 'styled-system';
const StyledSvg = styled('svg')(typography, color);

const Search = props => (
  <StyledSvg width="1em" height="1em" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M11 2a9 9 0 017.032 14.617l3.675 3.676a1 1 0 01-1.32 1.497l-.094-.083-3.676-3.675A9 9 0 1111 2zm0 2a7 7 0 104.865 12.033.732.732 0 01.078-.09l.09-.078A7 7 0 0011 4z"
      fill="currentColor"
      fillRule="nonzero"
    />
  </StyledSvg>
);
export default Search;
